// import React from 'react';
// import { Mic, Clock, MapPin, Star, Calendar, Award, Users, Sparkles, Zap } from 'lucide-react';
// import img1 from '../Assests/as.jpg';   
// import img2 from '../Assests/sj.jpg';
// import img3 from '../Assests/asr.jpg';


// const SpeakersSection = () => {
//  const guestSpeakers = [
//   {
//     name: "Prof. Ashutosh Sharma",
//     organization: "IIT Kanpur",
//     title: "Padma Shri Awardee",
//     image: img1,
//     talkTitle: "What makes S&T Work (or not!)",
//     time: "09:35 – 10:05 AM",
//     venue: "Dogra Hall",
//     isGuest: true,
//     // expertise: ["Advanced Materials", "Nanotechnology", "Surface Engineering", "Research Innovation"]
//   }
// ];

// const iitdSpeakers = [
//   {
//     name: "Prof. Sunil Jha",
//     department: "Mechanical Engineering, IITD",
//     image: img2,
//     talkTitle: "AI, Robotics and Future of Manufacturing",
//     time: "10:10 – 10:25 AM",
//     venue: "Dogra Hall",
//     isGuest: false,
//     expertise: ["AI & Robotics", "Advanced Manufacturing", "Industrial Automation", "Smart Systems"]
//   },
//   {
//     name: "Prof. Anurag S. Rathore",
//     department: "Chemical Engineering, IITD",
//     image: img3,
//     talkTitle: "Opportunities for contributing to the Indian Biotech Ecosystem",
//     time: "10:25 – 10:40 AM",
//     venue: "Dogra Hall",
//     isGuest: false,
//     expertise: ["Biotechnology", "Bioprocessing", "Pharmaceutical Engineering", "Drug Development"]
//   }
// ];

//   const SpeakerCard = ({ speaker, isGuest = false }) => (
//     <div className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-white via-gray-50 to-gray-100 shadow-2xl hover:shadow-[0_25px_60px_rgba(0,0,0,0.2)] transition-all duration-700 hover:scale-[1.02] border border-gray-300/50 backdrop-blur-sm">
//       {/* Animated Background Elements */}
//       <div className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ${
//         isGuest ? 'bg-gradient-to-br from-amber-50/60 via-orange-50/40 to-transparent' : 'bg-gradient-to-br from-blue-50/60 via-indigo-50/40 to-transparent'
//       }`}></div>
      
//       <div className={`absolute -top-20 -right-20 w-56 h-56 rounded-full blur-3xl opacity-20 group-hover:opacity-40 transition-all duration-1000 ${
//         isGuest ? 'bg-amber-300' : 'bg-blue-300'
//       }`}></div>
//       <div className={`absolute -bottom-20 -left-20 w-56 h-56 rounded-full blur-3xl opacity-20 group-hover:opacity-40 transition-all duration-1000 ${
//         isGuest ? 'bg-orange-300' : 'bg-indigo-300'
//       }`}></div>
      
//       <div className="relative p-8 lg:p-10">
//         <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 items-start">
          
//           {/* Speaker Image Section */}
//           <div className="flex-shrink-0 mx-auto lg:mx-0 relative">
//             <div className="relative">
//               {/* Glow Effect */}
//               <div className={`absolute -inset-3 rounded-2xl opacity-40 blur-xl group-hover:opacity-60 transition-opacity duration-700 ${
//                 isGuest ? 'bg-gradient-to-r from-amber-400 via-orange-500 to-amber-400' : 'bg-gradient-to-r from-blue-400 via-indigo-500 to-blue-400'
//               }`}></div>
              
//               {/* Image Container */}
//               <div className="relative w-48 h-48 lg:w-52 lg:h-52 rounded-2xl overflow-hidden border-4 border-white shadow-2xl backdrop-blur-sm group-hover:shadow-2xl transition-all duration-500">
//                 <img
//                   src={speaker.image}
//                   alt={speaker.name}
//                   className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
//                   onError={(e) => {
//                     e.target.src = "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80";
//                   }}
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//               </div>
              
//               {/* Guest Badge */}
//               <div className={`absolute -bottom-4 left-1/2 transform -translate-x-1/2 ${
//                 isGuest ? "bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500" : "bg-gradient-to-r from-blue-500 via-indigo-600 to-blue-500"
//               } text-white text-xs font-black px-6 py-2.5 rounded-full shadow-2xl whitespace-nowrap flex items-center gap-2 backdrop-blur-sm border-2 border-white/20 animate-pulse hover:scale-105 transition-transform duration-300`}>
//                 {isGuest && <Sparkles className="w-4 h-4" />}
//                 {isGuest ? "CHIEF GUEST" : "IIT DELHI FACULTY"}
//                 {!isGuest && <Users className="w-4 h-4" />}
//               </div>
//             </div>
//           </div>

//           {/* Speaker Details */}
//           <div className="flex-1 min-w-0 space-y-6 lg:space-y-7">
            
//             {/* Name and Titles */}
//             <div>
//               <h3 className="text-3xl lg:text-4xl font-black text-gray-900 mb-4 leading-tight tracking-tight group-hover:text-gray-800 transition-colors duration-300">
//                 {speaker.name}
//               </h3>
              
//               <div className="flex flex-wrap gap-3 mb-4">
//                 {speaker.title && (
//                   <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-amber-100 to-orange-100 text-amber-800 text-sm font-bold rounded-xl border border-amber-300 backdrop-blur-sm hover:shadow-lg transition-all duration-300">
//                     <Award className="w-4 h-4" />
//                     {speaker.title}
//                   </span>
//                 )}
                
//                 {speaker.organization && (
//                   <span className="inline-flex items-center px-5 py-2.5 bg-blue-100 text-blue-800 text-sm font-bold rounded-xl border border-blue-300 backdrop-blur-sm hover:shadow-lg transition-all duration-300">
//                     🏛️ {speaker.organization}
//                   </span>
//                 )}
                
//                 {speaker.department && (
//                   <span className="inline-flex items-center px-5 py-2.5 bg-purple-100 text-purple-800 text-sm font-bold rounded-xl border border-purple-300 backdrop-blur-sm hover:shadow-lg transition-all duration-300">
//                     🎓 {speaker.department}
//                   </span>
//                 )}
//               </div>
//             </div>

//             {/* Talk Details */}
//             <div className="grid grid-cols-1 gap-4">
//               {/* Talk Title */}
//               <div className="flex items-start gap-4 bg-white/80 backdrop-blur-xl rounded-2xl p-5 border border-gray-200/80 hover:bg-white hover:border-gray-300 hover:shadow-lg transition-all duration-300">
//                 <div className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center shadow-lg ${
//                   isGuest ? 'bg-gradient-to-br from-amber-500 to-orange-600' : 'bg-gradient-to-br from-blue-500 to-indigo-600'
//                 } group-hover:scale-110 transition-transform duration-300`}>
//                   <Mic className="w-6 h-6 text-white" />
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <p className={`text-xs font-black mb-2 uppercase tracking-widest ${
//                     isGuest ? 'text-amber-600' : 'text-blue-600'
//                   }`}>Featured Talk</p>
//                   <p className="text-lg font-bold text-gray-900 leading-snug group-hover:text-gray-800 transition-colors duration-300">
//                     {speaker.talkTitle}
//                   </p>
//                 </div>
//               </div>
              
//               {/* Time and Venue */}
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//                 <div className="flex items-start gap-3 bg-white/80 backdrop-blur-xl rounded-2xl p-5 border border-gray-200/80 hover:bg-white hover:border-gray-300 hover:shadow-lg transition-all duration-300">
//                   <div className="flex-shrink-0 w-11 h-11 bg-gradient-to-br from-emerald-500 to-green-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
//                     <Clock className="w-5 h-5 text-white" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-xs text-emerald-600 font-black mb-1 uppercase tracking-wider">Session Time</p>
//                     <p className="text-sm font-bold text-gray-900 leading-tight group-hover:text-gray-800">{speaker.time}</p>
//                   </div>
//                 </div>

//                 <div className="flex items-start gap-3 bg-white/80 backdrop-blur-xl rounded-2xl p-5 border border-gray-200/80 hover:bg-white hover:border-gray-300 hover:shadow-lg transition-all duration-300">
//                   <div className="flex-shrink-0 w-11 h-11 bg-gradient-to-br from-pink-500 to-rose-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
//                     <MapPin className="w-5 h-5 text-white" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-xs text-pink-600 font-black mb-1 uppercase tracking-wider">Venue</p>
//                     <p className="text-sm font-bold text-gray-900 leading-tight group-hover:text-gray-800">{speaker.venue}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

    
//           </div>
//         </div>
//       </div>
      
//       {/* Bottom Border Effects */}
//       <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-gray-400/50 to-transparent"></div>
//       <div className={`absolute bottom-0 left-0 right-0 h-0.5 ${
//         isGuest ? "bg-gradient-to-r from-transparent via-amber-500 to-transparent" : "bg-gradient-to-r from-transparent via-blue-500 to-transparent"
//       } group-hover:via-opacity-100 transition-all duration-700`}></div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-100 via-white to-gray-200 py-20 relative overflow-hidden">
//       {/* Background Elements */}
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-100/50 via-transparent to-transparent"></div>
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-indigo-100/30 via-transparent to-transparent"></div>
//       <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzM3NDE1MSIgc3Ryb2tlLXdpZHRoPSIwLjUiIG9wYWNpdHk9IjAuMDMiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-10"></div>
      
//       <div className="container mx-auto px-4 max-w-6xl relative">
        
//         {/* Header Section */}
//         <div className="text-center mb-20 mt-10">
//           <div className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-100 to-indigo-100 backdrop-blur-xl border-2 border-blue-300/80 rounded-2xl px-8 py-4 shadow-2xl mb-8 hover:shadow-3xl transition-all duration-300">
//             <div className="w-2.5 h-2.5 bg-blue-500 rounded-full animate-pulse"></div>
//             <Mic className="w-7 h-7 text-blue-600" />
//             <span className="text-blue-700 font-black text-lg tracking-wide">Open House 2026</span>
//           </div>
          
//           <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-8 tracking-tighter">
//             Featured <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent animate-pulse">Speakers</span>
//           </h1>
          
//           <div className="flex items-center justify-center gap-3 mb-8">
//             <div className="w-24 h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent rounded-full"></div>
//             <Zap className="w-6 h-6 text-blue-600 animate-bounce" />
//             <div className="w-24 h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent rounded-full"></div>
//           </div>
          
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed font-medium">
//             Join distinguished experts and renowned IIT Delhi faculty for cutting-edge research 
//             and innovation in technology and engineering. Experience groundbreaking insights from leading minds.
//           </p>
//         </div>

//         {/* Chief Guest Section */}
//         <div className="mb-24">
//           <div className="text-center mb-12">
//             <div className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-100 to-orange-100 backdrop-blur-xl text-gray-900 px-8 py-4 rounded-2xl mb-6 shadow-2xl border-2 border-amber-300/80 hover:shadow-3xl transition-all duration-300">
//               <Star className="w-6 h-6 fill-amber-600 text-amber-600" />
//               <span className="font-black text-lg uppercase tracking-widest">Chief Guest</span>
//             </div>
//             <h2 className="text-4xl md:text-5xl font-black text-gray-900 bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">
//               Distinguished Speaker
//             </h2>
//           </div>
          
//           {guestSpeakers.map((speaker, index) => (
//             <SpeakerCard key={index} speaker={speaker} isGuest={true} />
//           ))}
//         </div>

//         {/* IIT Delhi Faculty Section */}
//         <div className="mb-24">
//           <div className="text-center mb-12">
//             <div className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-100 to-indigo-100 backdrop-blur-xl text-gray-900 px-8 py-4 rounded-2xl mb-6 shadow-2xl border-2 border-blue-300/80 hover:shadow-3xl transition-all duration-300">
//               <Users className="w-6 h-6 text-blue-600" />
//               <span className="font-black text-lg uppercase tracking-widest">IIT Delhi Faculty</span>
//             </div>
//             <h2 className="text-4xl md:text-5xl font-black text-gray-900 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
//               Expert Sessions
//             </h2>
//           </div>
          
//           <div className="space-y-8">
//             {iitdSpeakers.map((speaker, index) => (
//               <SpeakerCard key={index} speaker={speaker} isGuest={false} />
//             ))}
//           </div>
//         </div>

//         {/* Session Timeline */}
//         <div className="bg-gradient-to-br from-white to-gray-50 backdrop-blur-2xl rounded-3xl p-8 lg:p-12 mb-20 border-2 border-gray-300/50 shadow-2xl hover:shadow-3xl transition-all duration-500">
//           <h3 className="text-3xl lg:text-4xl font-black text-gray-900 mb-4 text-center">
//             📅 Session Timeline
//           </h3>
//           <p className="text-center text-blue-600 font-bold text-lg mb-12 flex items-center justify-center gap-2">
//             <MapPin className="w-5 h-5" />
//             Dogra Hall, IIT Delhi
//           </p>
          
//           <div className="space-y-4">
//             {guestSpeakers.concat(iitdSpeakers).map((speaker, index) => (
//               <div key={index} className="flex items-start gap-5 p-6 bg-gradient-to-r from-white to-gray-50/80 backdrop-blur-xl rounded-2xl border-2 border-gray-300/50 hover:border-gray-400/80 hover:scale-[1.02] hover:shadow-xl transition-all duration-300 group">
//                 <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
//                   <Clock className="w-7 h-7 text-white" />
//                 </div>
//                 <div className="flex-1">
//                   <div className="text-sm font-black text-blue-600 mb-2 tracking-wide">{speaker.time}</div>
//                   <h4 className="text-xl font-black text-gray-900 mb-2 group-hover:text-gray-800 transition-colors duration-300">
//                     {speaker.name}
//                   </h4>
//                   <p className="text-gray-600 text-base mb-3 font-semibold">{speaker.talkTitle}</p>
//                   <div className="flex items-center gap-2 text-sm text-gray-500 font-bold">
//                     <MapPin className="w-4 h-4" />
//                     {speaker.venue}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Event Info Section */}
//         <div className="bg-gradient-to-br from-blue-100 via-indigo-100 to-purple-100 rounded-3xl p-12 lg:p-16 text-gray-900 text-center shadow-2xl relative overflow-hidden border-2 border-gray-300/50 hover:shadow-3xl transition-all duration-500">
//           <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzM3NDE1MSIgc3Ryb2tlLXdpZHRoPSIxIiBvcGFjaXR5PSIwLjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-10"></div>
          
//           <div className="relative">
//             <div className="w-24 h-24 bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-2xl animate-pulse hover:scale-110 transition-transform duration-300">
//               <Award className="w-12 h-12 text-white" />
//             </div>
            
//             <h2 className="text-4xl md:text-5xl font-black mb-8 tracking-tight bg-gradient-to-r from-blue-800 to-purple-800 bg-clip-text text-transparent">
//               Join Open House 2026
//             </h2>
//             <p className="text-blue-800 text-xl mb-12 max-w-2xl mx-auto font-semibold">
//               Experience groundbreaking research and innovation from IIT Delhi's finest minds. 
//               Don't miss this opportunity to learn from the best in the field.
//             </p>
            
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 max-w-4xl mx-auto">
//               <div className="bg-white/80 backdrop-blur-xl border-2 border-gray-300/80 rounded-2xl p-8 hover:bg-white hover:scale-105 hover:shadow-xl transition-all duration-300 group">
//                 <MapPin className="w-14 h-14 text-yellow-600 mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" />
//                 <h3 className="font-black text-xl mb-2 text-gray-800">Venue</h3>
//                 <p className="text-blue-800 font-bold">Dogra Hall, IIT Delhi</p>
//               </div>
              
//               <div className="bg-white/80 backdrop-blur-xl border-2 border-gray-300/80 rounded-2xl p-8 hover:bg-white hover:scale-105 hover:shadow-xl transition-all duration-300 group">
//                 <Calendar className="w-14 h-14 text-yellow-600 mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" />
//                 <h3 className="font-black text-xl mb-2 text-gray-800">Date</h3>
//                 <p className="text-blue-800 font-bold">October 31, 2026</p>
//               </div>
              
//               <div className="bg-white/80 backdrop-blur-xl border-2 border-gray-300/80 rounded-2xl p-8 hover:bg-white hover:scale-105 hover:shadow-xl transition-all duration-300 group">
//                 <Clock className="w-14 h-14 text-yellow-600 mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" />
//                 <h3 className="font-black text-xl mb-2 text-gray-800">Time</h3>
//                 <p className="text-blue-800 font-bold">09:35 AM - 10:40 AM</p>
//               </div>
//             </div>
            
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SpeakersSection;







import React from 'react'
import { BellRing, Calendar, Clock, Mic } from 'lucide-react'

const SpeakersSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50 py-20" aria-labelledby="speakers-title">
      <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-blue-200/30 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-amber-200/30 blur-3xl" />

      <div className="container relative mx-auto max-w-5xl px-4">
        <div className="mb-12 text-center">
          <div className="mb-5 mt-10 inline-flex items-center gap-2 rounded-full bg-blue-100 px-4 py-2 text-sm font-bold uppercase tracking-widest text-blue-700">
            <Mic className="h-4 w-4" aria-hidden="true" />
            Featured Speakers
          </div>
          <h1 id="speakers-title" className="mb-4 text-4xl font-black text-slate-900 md:text-5xl">
            Speakers To Be Announced
          </h1>
          <p className="mx-auto max-w-2xl text-lg leading-8 text-slate-600">
            Our distinguished guests and IIT Delhi faculty lineup will be revealed soon.
          </p>
        </div>

        <div className="overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-blue-100">
          <div className="bg-gradient-to-r from-blue-700 to-indigo-700 px-6 py-9 text-white md:px-10">
            <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-4">
                <div className="rounded-2xl bg-white/15 p-3 ring-1 ring-white/25">
                  <BellRing className="h-8 w-8" aria-hidden="true" />
                </div>
                <div>
                  <p className="text-sm font-semibold uppercase tracking-widest text-blue-100">Open House 2026</p>
                  <h2 className="mt-1 text-2xl font-bold">Speaker lineup coming soon</h2>
                </div>
              </div>
              <span className="w-fit rounded-full bg-amber-300 px-4 py-2 text-sm font-bold text-amber-950">
                TBA
              </span>
            </div>
          </div>

          <div className="grid gap-4 px-6 py-10 sm:grid-cols-2 md:px-10">
            <div className="flex items-center gap-4 rounded-2xl bg-slate-50 p-5 ring-1 ring-slate-200">
              <Calendar className="h-7 w-7 text-blue-600" aria-hidden="true" />
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Event date</p>
                <p className="font-bold text-slate-900">October 31, 2026</p>
              </div>
            </div>
            <div className="flex items-center gap-4 rounded-2xl bg-slate-50 p-5 ring-1 ring-slate-200">
              <Clock className="h-7 w-7 text-indigo-600" aria-hidden="true" />
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Session details</p>
                <p className="font-bold text-slate-900">To be announced</p>
              </div>
            </div>
          </div>

          <p className="border-t border-slate-100 px-6 py-6 text-center text-slate-500 md:px-10">
            Please check back soon for speaker names, talks, timings, and venues.
          </p>
        </div>
      </div>
    </section>
  )
}

export default SpeakersSection
